import { render, staticRenderFns } from "./ConfigCard.vue?vue&type=template&id=7c0a8d9c&scoped=true&"
import script from "./ConfigCard.vue?vue&type=script&lang=js&"
export * from "./ConfigCard.vue?vue&type=script&lang=js&"
import style0 from "./ConfigCard.vue?vue&type=style&index=0&id=7c0a8d9c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c0a8d9c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VFileInput } from 'vuetify/lib/components/VFileInput';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
installComponents(component, {VBtn,VCard,VCol,VFileInput,VIcon,VRow,VSnackbar})
